export default __webpack_public_path__ + "static/media/high_pool.5f62b6cd.jpg";